import { emptyArray } from 'ui-components/default-props/empty';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as Actions from './batches.label-batch-status-modal.actions';
import { SAVE_OR_EDIT_BATCH_NOTE_SUCCESS } from '../notes/batch-note.actions';
import { LABEL_SERVICE_BATCH_STATUS_IDS } from '../../../constants/label-batch-status-ids';

const initialState = {
  batches: emptyArray,
  errorsAndWarnings: emptyArray,
};

const updateBatchNote = (state, { batchId, note }) => {
  const matchingBatchIndex = state.batches.findIndex((b) => b.batchId === batchId);
  if (matchingBatchIndex < 0) {
    return state;
  }
  const updatedBatch = {
    ...state.batches[matchingBatchIndex],
    batchNotes: note,
  };
  return {
    ...state,
    batches: [...state.batches.slice(0, matchingBatchIndex), updatedBatch, ...state.batches.slice(matchingBatchIndex + 1)],
  };
};

const updateBatchStatusToArchived = (state, batchIds) => {
  const matchingBatchIndex = state.batches.findIndex((b) => b.batchId === batchIds[0]);
  if (matchingBatchIndex < 0) {
    return state;
  }
  const updatedBatch = {
    ...state.batches[matchingBatchIndex],
    statusId: LABEL_SERVICE_BATCH_STATUS_IDS.ARCHIVED,
  };
  return {
    ...state,
    batches: [...state.batches.slice(0, matchingBatchIndex), updatedBatch, ...state.batches.slice(matchingBatchIndex + 1)],
  };
};

const initialFormOfBatchToErrorOrWarning = (batchId) => ({
  batchId,
  isLoading: true,
  items: [],
  isExpanded: true,
});

const updatedFormOfBatchToErrorOrWarning = (batchId, response) => ({
  batchId,
  isLoading: false,
  items: response,
  isExpanded: true,
});

const addOrClearErrorOrWarnState = (state, batchId) => {
  const { errorsAndWarnings } = state;
  const foundObj = errorsAndWarnings.find((errOrWarn) => errOrWarn.batchId === batchId);
  if (!foundObj) {
    return [...errorsAndWarnings, initialFormOfBatchToErrorOrWarning(batchId)];
  }
  return [...errorsAndWarnings.filter((errOrWarn) => errOrWarn.batchId !== batchId), initialFormOfBatchToErrorOrWarning(batchId)];
};

const updateErrorOrWarnState = (state, response) => {
  if (!response || !response.length) {
    return [];
  }
  const batchId = response[0].labelBatchId.toString();
  const { errorsAndWarnings } = state;
  const foundObj = errorsAndWarnings.find((errOrWarn) => errOrWarn.batchId === batchId);
  if (!foundObj) {
    return [...errorsAndWarnings, updatedFormOfBatchToErrorOrWarning(batchId, response)];
  }
  const updatedArray = errorsAndWarnings.filter((errOrWarn) => errOrWarn.batchId !== batchId);
  updatedArray.push(updatedFormOfBatchToErrorOrWarning(batchId, response));
  return updatedArray;
};

const resetRetriedBatch = (state, batchId) => {
  const stateBatches = state.batches;
  const batchIndex = stateBatches.findIndex((batch) => batch.batchId === batchId);
  const batch = stateBatches[batchIndex];
  const resetBatchStatus = {
    batchId: batch.batchId,
    batchNumber: batch.batchNumber,
    total: batch.total,
  };

  return {
    ...state,
    batches: [...stateBatches.slice(0, batchIndex), resetBatchStatus, ...stateBatches.slice(batchIndex + 1)],
    errorsAndWarnings: state.errorsAndWarnings.filter((errWarn) => errWarn.batchId !== batchId),
  };
};

const actionHandlerMap = {
  [Actions.CLEAR_LABEL_BATCH_STATUS_MODAL_BATCHES]: (state) => {
    return {
      ...state,
      batches: emptyArray,
    };
  },
  [Actions.ADD_LABEL_BATCH_STATUS_MODAL_BATCH]: (state, { batch }) => {
    const { batches } = state;
    const stringifiedBatch = { ...batch, batchId: batch.batchId.toString() };
    const foundBatchIndex = batches.findIndex((b) => b.batchId === batch.batchId.toString());
    if (foundBatchIndex !== -1) {
      return {
        ...state,
        batches: [...batches.slice(0, foundBatchIndex), stringifiedBatch, ...batches.slice(foundBatchIndex + 1)],
      };
    }
    return {
      ...state,
      batches: [stringifiedBatch, ...batches],
    };
  },
  [SAVE_OR_EDIT_BATCH_NOTE_SUCCESS]: (state, action) => updateBatchNote(state, action),
  [Actions.LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_REQUEST]: (state, { batchId }) => ({
    ...state,
    errorsAndWarnings: addOrClearErrorOrWarnState(state, batchId),
  }),
  [Actions.LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_SUCCESS]: (state, { response }) => ({
    ...state,
    errorsAndWarnings: updateErrorOrWarnState(state, response),
  }),
  [Actions.ON_RETRY_BATCH_IN_LABEL_BATCH_STATUS_MODAL_REQUEST]: (state, { batchId }) => resetRetriedBatch(state, batchId),
  [Actions.LABEL_BATCH_STATUS_MODAL_ARCHIVE_BATCHES_SUCCESS]: (state, { batchIds }) => updateBatchStatusToArchived(state, batchIds),
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './batches.label-batch-status-modal.reducer.metadata';
